export default "__VITE_ASSET__a1ed1b43__"